module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/consigner.27e7fa7c.svg";